(() => {
  const init = (root) => {
    if (!root || root.dataset.pwBrandInit) return;

    root.dataset.pwBrandInit = '1';

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    /* -----------------------------------------
       Scroll reveal
       ----------------------------------------- */
    const revealItems = root.querySelectorAll('.pw-reveal');

    if (
      reduceMotion ||
      !('IntersectionObserver' in window)
    ) {
      revealItems.forEach((item) => {
        item.classList.add('is-visible');
      });
    } else {
      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px -8%'
        }
      );

      revealItems.forEach((item) => {
        revealObserver.observe(item);
      });
    }

    /* -----------------------------------------
       Page progress line
       ----------------------------------------- */
    const progressBar = root.querySelector(
      '.pw-brand__progress span'
    );

    const updateProgress = () => {
      if (!progressBar) return;

      const rect = root.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight;

      const scrollableHeight = Math.max(
        1,
        root.offsetHeight - viewportHeight
      );

      const distanceTravelled = Math.min(
        scrollableHeight,
        Math.max(0, -rect.top)
      );

      progressBar.style.transform =
        `scaleX(${distanceTravelled / scrollableHeight})`;
    };

    updateProgress();

    window.addEventListener(
      'scroll',
      updateProgress,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateProgress,
      { passive: true }
    );

    /* -----------------------------------------
       Lookbook drag / keyboard scrolling
       ----------------------------------------- */
    root
      .querySelectorAll('[data-pw-brand-rail]')
      .forEach((rail) => {
        let isDragging = false;
        let startX = 0;
        let startScrollLeft = 0;

        rail.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch') return;

          isDragging = true;
          startX = event.clientX;
          startScrollLeft = rail.scrollLeft;

          if (rail.setPointerCapture) {
            rail.setPointerCapture(event.pointerId);
          }
        });

        rail.addEventListener('pointermove', (event) => {
          if (!isDragging) return;

          event.preventDefault();

          rail.scrollLeft =
            startScrollLeft -
            (event.clientX - startX);
        });

        const stopDragging = (event) => {
          isDragging = false;

          if (rail.releasePointerCapture) {
            try {
              rail.releasePointerCapture(event.pointerId);
            } catch (_) {
              /* Pointer may already be released */
            }
          }
        };

        [
          'pointerup',
          'pointercancel',
          'pointerleave'
        ].forEach((eventName) => {
          rail.addEventListener(
            eventName,
            stopDragging
          );
        });

        rail.addEventListener('keydown', (event) => {
          if (
            event.key !== 'ArrowLeft' &&
            event.key !== 'ArrowRight'
          ) {
            return;
          }

          event.preventDefault();

          const direction =
            event.key === 'ArrowRight'
              ? 1
              : -1;

          rail.scrollBy({
            left:
              rail.clientWidth *
              0.7 *
              direction,
            behavior:
              reduceMotion
                ? 'auto'
                : 'smooth'
          });
        });
      });
  };

  const boot = () => {
    document
      .querySelectorAll(
        '[data-pw-brand-editorial]'
      )
      .forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      { once: true }
    );
  } else {
    boot();
  }

  /* Re-initialise when Shopify reloads the section
     inside the Theme Editor. */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      event.target
        .querySelectorAll?.(
          '[data-pw-brand-editorial]'
        )
        .forEach(init);
    }
  );
})();
